var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticStyle: { "margin-top": "1vh" },
          attrs: {
            visible: _vm.dialogVisible,
            "modal-append-to-body": false,
            width: "1000px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "title", attrs: { slot: "title" }, slot: "title" },
            [_vm._v("员工群聊统计")]
          ),
          _c(
            "div",
            { staticClass: "table-container" },
            [
              _c(
                "div",
                { staticClass: "btn-wrap" },
                [
                  _c(
                    "el-tag",
                    {
                      staticClass: "select-stafft-wrap",
                      attrs: {
                        title: "选择员工",
                        closable:
                          _vm.searchMenNames.length === 0 ? false : true,
                        type: "medium",
                        effect: "plain"
                      },
                      on: {
                        close: _vm.searchCloseTag,
                        click: function($event) {
                          return _vm.clickAddMember()
                        }
                      }
                    },
                    [
                      _vm.searchMenNames.length === 0
                        ? _c("span", [_vm._v("选择员工")])
                        : _vm._e(),
                      _vm._l(_vm.searchMenNames, function(item, index) {
                        return _c(
                          "span",
                          { key: index, staticClass: "staff-names" },
                          [
                            _vm._v(_vm._s(item.name)),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.searchMenNames.length > 1 &&
                                      index != _vm.searchMenNames.length - 1,
                                    expression:
                                      "\n                searchMenNames.length > 1 &&\n                  index != searchMenNames.length - 1\n              "
                                  }
                                ]
                              },
                              [_vm._v(",")]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _c("el-date-picker", {
                    staticStyle: { width: "240px" },
                    attrs: {
                      size: "mini",
                      editable: false,
                      type: "daterange",
                      "value-format": "yyyy-MM-dd",
                      "range-separator": "-",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      "picker-options": _vm.pickerOptions,
                      clearable: ""
                    },
                    on: { change: _vm.selectTime },
                    model: {
                      value: _vm.searchSelectTime,
                      callback: function($$v) {
                        _vm.searchSelectTime = $$v
                      },
                      expression: "searchSelectTime"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "table-data" },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading"
                        }
                      ],
                      ref: "singleTable",
                      staticStyle: {
                        width: "100%",
                        height: "100%",
                        "font-size": "13px"
                      },
                      attrs: {
                        size: "medium",
                        "header-cell-style": {
                          background: "#eef1f6",
                          color: "#606266"
                        },
                        "highlight-current-row": true,
                        data: _vm.tableData,
                        "default-sort": {
                          prop: "bindDangAnCount",
                          order: "descending"
                        },
                        height: "308px"
                      },
                      on: { "sort-change": _vm.customerSortChange }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          prop: "userName",
                          label: "员工姓名",
                          width: "100",
                          align: "left"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "chatTotal",
                          label: "创建群聊数",
                          "min-width": "110",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function() {
                              return [
                                _c("span", [
                                  _vm._v("创建群聊数"),
                                  _c("i", {
                                    staticClass: "el-icon-question",
                                    staticStyle: { color: "#aaa" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openTipDialog(1)
                                      }
                                    }
                                  })
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "memberTotal",
                          label: "群聊人数",
                          "min-width": "110",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function() {
                              return [
                                _c("span", [
                                  _vm._v("群聊人数"),
                                  _c("i", {
                                    staticClass: "el-icon-question",
                                    staticStyle: { color: "#aaa" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openTipDialog(1)
                                      }
                                    }
                                  })
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "msgTotal",
                          label: "群聊消息数",
                          "min-width": "110",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function() {
                              return [
                                _c("span", [
                                  _vm._v("群聊消息数"),
                                  _c("i", {
                                    staticClass: "el-icon-question",
                                    staticStyle: { color: "#aaa" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openTipDialog(1)
                                      }
                                    }
                                  })
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "memberHasMsg",
                          label: "活跃群成员数",
                          "min-width": "130",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function() {
                              return [
                                _c("span", [
                                  _vm._v("活跃群成员数"),
                                  _c("i", {
                                    staticClass: "el-icon-question",
                                    staticStyle: { color: "#aaa" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openTipDialog(1)
                                      }
                                    }
                                  })
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "newChatCnt",
                          label: "新增群聊数",
                          "min-width": "130",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function() {
                              return [
                                _c("span", [
                                  _vm._v("新增群聊数"),
                                  _c("i", {
                                    staticClass: "el-icon-question",
                                    staticStyle: { color: "#aaa" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openTipDialog(1)
                                      }
                                    }
                                  })
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "newMemberCnt",
                          label: "新增群人数",
                          "min-width": "130",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "header",
                            fn: function() {
                              return [
                                _c("span", [
                                  _vm._v("新增群人数"),
                                  _c("i", {
                                    staticClass: "el-icon-question",
                                    staticStyle: { color: "#aaa" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openTipDialog(1)
                                      }
                                    }
                                  })
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("el-pagination", {
                attrs: {
                  background: true,
                  "current-page": _vm.pageparm.currentPage,
                  "page-size": _vm.pageparm.pageSize,
                  layout: "prev, pager, next, jumper",
                  total: _vm.pageparm.total
                },
                on: {
                  "current-change": _vm.callBack,
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.pageparm, "currentPage", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.pageparm, "currentPage", $event)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ]
      ),
      _vm.staffTreeShow
        ? _c("StaffTree", {
            ref: "StaffTreeRef",
            attrs: {
              title: "选择成员",
              dialogVisibleTree: _vm.dialogVisibleTree,
              currentSelectMember: _vm.currentSelectMember
            },
            on: {
              closeTree: _vm.closeTree,
              clickSubmitTree: _vm.clickSubmitTree
            }
          })
        : _vm._e(),
      _c("StatisticDialog", { ref: "tipDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }